import { API_ERROR_LOG, ERROR_LOG, NAVIGATE_LOG } from '../../config/log';
/**
 *
 * @param {string} sourceRoute - from which route
 * @param {string} targetRoute - to which route
 * @returns
 */
export function getNavigateLogEntry(sourceRoute, targetRoute) {
    const level = NAVIGATE_LOG.DEFAULT_LEVEL;
    const msg = `route to '${targetRoute}'`;
    const payload = {
        type: NAVIGATE_LOG.PAYLOAD_TYPE,
        sourceRoute,
        targetRoute,
    };
    return { level, msg, payload };
}
/**
 * @description
 * Get the error log entry to log error in the ErrorBoundary component.
 * @param {Error} error
 * @returns
 */
export function getErrorLogEntry(error) {
    const level = ERROR_LOG.DEFAULT_LEVEL;
    const msg = error.message;
    const payload = {
        type: ERROR_LOG.PAYLOAD_TYPE,
        errorMsg: error.stack ? error.stack.replace(/\n/g, '\\n') : '',
    };
    return { level, msg, payload };
}
/**
 * @description
 * Get the error log entry to log error on the ApiError page.
 * @param {string} errMessage
 * @param {string} errorCode
 * @returns
 */
export function getApiErrorLogEntry(errMessage, errorCode) {
    const level = API_ERROR_LOG.DEFAULT_LEVEL;
    const msg = errMessage;
    const payload = {
        type: API_ERROR_LOG.PAYLOAD_TYPE,
        errorCode,
    };
    return { level, msg, payload };
}
/**
 * @description
 * Get the error log entry to log error on the Error page.
 * @param {string} errMessage
 * @param {string} errorCode
 * @returns
 */
export function getErrorPageLogEntry(errMessage, errorCode) {
    const level = ERROR_LOG.DEFAULT_LEVEL;
    const msg = errMessage;
    const payload = {
        type: ERROR_LOG.PAYLOAD_TYPE,
        errorCode,
    };
    return { level, msg, payload };
}
